export default __webpack_public_path__ + "static/media/temp stay E2 - Intra Corporate Transfer.cace4024.jpg";